import { useUserContext } from "@dexteel/mesf-core";
import { createContext, type ReactNode, useContext } from "react";

const CalendarAreaContext = createContext<number | null>(null);

export const CalendarAreaProvider = ({
	areaId,
	children,
}: {
	areaId?: number;
	children: ReactNode;
}) => (
	<CalendarAreaContext.Provider value={areaId ?? null}>
		{children}
	</CalendarAreaContext.Provider>
);

export const useCalendarAreaId = (): number | string | null => {
	const override = useContext(CalendarAreaContext);
	const {
		state: { defaultAreaId },
	} = useUserContext();
	return override ?? defaultAreaId;
};
